module.exports = __webpack_public_path__ + "img/capitol_hill_library_9610_3.53f4a6ce.jpg";